import React from 'react'
import { NavLink, Link, withRouter } from 'react-router-dom'
import { translate } from 'react-i18next'
import { compose, withHandlers } from 'recompose'
import routes from '../../routes/root/routes'
import styles from './siteNavComponent.scss'
import Logo from '../../assets/icons/logoMapMyGrad.svg'
import SiteNavDropdown from '../siteNavDropdown/siteNavDropdownComponent'
import ContentContainer from '../contentContainer/contentContainerComponent'
import SmallNav from '../../containers/smallNav/smallNavContainer'
import PropTypes from 'prop-types'

export function SiteNav (props: Props) {
  const { t } = props

  const isSubrouteActive = subRoute => {
    let pathName = props.location.pathname

    switch (subRoute) {
      case 'about':
        return pathName === routes.aboutBasics || pathName === routes.aboutFaq
      case 'findyourpath':
        return (
          pathName === routes.findYourPath ||
          pathName === routes.takeTheQuiz ||
          pathName === routes.roadmapToCollege ||
          pathName === routes.artsHumanitiesCareers ||
          pathName === routes.businessIndustryCareers ||
          pathName === routes.multidisciplinaryCareers ||
          pathName === routes.publicServiceCareers ||
          pathName === routes.stemCareers
        )
      case 'endorsements':
        return (
          pathName === routes.endorsements ||
          pathName === routes.artsHumanities ||
          pathName === routes.businessIndustry ||
          pathName === routes.multidisciplinary ||
          pathName === routes.publicService ||
          pathName === routes.stem
        )
      default:
        return false
    }
  }
  return (
    <header className={styles.fixed}>
      <SmallNav />
      <div className={styles.appHeader}>
        <ContentContainer element='nav' className={styles.headerNav}>
          <div className={styles.headerNavHeader}>
            <Link to='/' aria-label={'Home'}>
              <figure className={styles.headerLogo}>
                <Logo />
              </figure>
            </Link>
            <button
              className={[
                styles.navbarCollapseButton,
                props.showNavbar ? styles.navbarCollapseButtonActive : null
              ].join(' ')}
              onClick={props.toggleNavbar}
              aria-expanded={props.showNavbar ? 'true' : 'false'}
            >
              <span className={styles.srOnly}>Toggle navigation</span>
              <span className={styles.iconBar} />
              <span className={styles.iconBar} />
              <span className={styles.iconBar} />
            </button>
          </div>
          <ul
            className={[
              styles.navMenu,
              props.showNavbar ? styles.display : null
            ].join(' ')}
          >
            <SiteNavDropdown
              buttonClass={styles.navLink}
              toggleDropdown={props.toggleAboutDropdown}
              showDropdown={props.showAboutDropdown}
              isSubrouteActive={isSubrouteActive('about')}
              buttonLabel={t('nav:about')}
            >
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.aboutBasics}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeAboutDropdown}
                  exact
                >
                  {t('nav:about')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.theBasics}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeAboutDropdown}
                  strict
                >
                  {t('nav:basics')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.aboutFaq}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeAboutDropdown}
                  strict
                >
                  {t('nav:faq')}
                </NavLink>
              </li>
            </SiteNavDropdown>
            <SiteNavDropdown
              buttonClass={styles.navLink}
              toggleDropdown={props.toggleQuizDropdown}
              showDropdown={props.showQuizDropdown}
              isSubrouteActive={isSubrouteActive('findyourpath')}
              buttonLabel={t('nav:findyourpath')}
            >
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.findYourPath}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeQuizDropdown}
                  strict
                >
                  {t('nav:findyourpath')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.roadmapToCollege}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeQuizDropdown}
                  strict
                >
                  {t('nav:roadmapToCollege')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.takeTheQuiz}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeQuizDropdown}
                  strict
                >
                  {t('nav:takethequiz')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.artsHumanitiesCareers}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeQuizDropdown}
                  strict
                >
                  {t('artsHumanities:title')} {t('career:careers')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.businessIndustryCareers}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeQuizDropdown}
                  strict
                >
                  {t('businessIndustry:title')} {t('career:careers')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.multidisciplinaryCareers}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeQuizDropdown}
                  strict
                >
                  {t('multidisciplinary:title')} {t('career:careers')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.publicServiceCareers}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeQuizDropdown}
                  strict
                >
                  {t('publicService:title')} {t('career:careers')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.stemCareers}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeQuizDropdown}
                  strict
                >
                  {t('stem:smallTitle')} {t('career:careers')}
                </NavLink>
              </li>
            </SiteNavDropdown>
            <SiteNavDropdown
              buttonClass={styles.navLink}
              toggleDropdown={props.toggleEndorsementDropdown}
              showDropdown={props.showEndorsementDropdown}
              isSubrouteActive={isSubrouteActive('endorsements')}
              buttonLabel={t('nav:endorsements')}
            >
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.endorsements}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeEndorsementDropdown}
                  exact
                >
                  {t('nav:endorsements')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.artsHumanities}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeEndorsementDropdown}
                  strict
                >
                  {t('artsHumanities:title')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.businessIndustry}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeEndorsementDropdown}
                  strict
                >
                  {t('businessIndustry:title')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.multidisciplinary}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeEndorsementDropdown}
                  strict
                >
                  {t('multidisciplinary:title')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.publicService}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeEndorsementDropdown}
                  strict
                >
                  {t('publicService:title')}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={styles.navLink}
                  to={routes.stem}
                  activeClassName={styles.dropdownActiveLink}
                  onClick={props.closeEndorsementDropdown}
                  strict
                >
                  {t('stem:smallTitle')}
                </NavLink>
              </li>
            </SiteNavDropdown>
            {!props.siteMaintBlockGradPlanner && (
            <li>
              <NavLink
                className={styles.navLink}
                to='/gradplanner'
                activeClassName={styles.activeLink}
                onClick={props.toggleNavbar}
                strict
              >
                {t('nav:gradPlanner')}
              </NavLink>
            </li>
            )}
          </ul>
        </ContentContainer>
      </div>
    </header>
  )
}
SiteNav.propTypes = {
  t: PropTypes.func.isRequired,
  showEndorsementDropdown: PropTypes.bool.isRequired,
  showQuizDropdown: PropTypes.bool.isRequired,
  showAboutDropdown: PropTypes.bool.isRequired,
  showNavbar: PropTypes.bool.isRequired,
  toggleEndorsementDropdown: PropTypes.func.isRequired,
  toggleQuizDropdown: PropTypes.func.isRequired,
  toggleAboutDropdown: PropTypes.func.isRequired,
  toggleNavbar: PropTypes.func.isRequired,
  closeEndorsementDropdown: PropTypes.func.isRequired,
  closeQuizDropdown: PropTypes.func.isRequired,
  closeAboutDropdown: PropTypes.func.isRequired,
  location: PropTypes.any,
  siteMaintBlockGradPlanner: PropTypes.bool.isRequired
}

export const handlers = {
  closeQuizDropdown: props => e => {
    if (props.toggleQuizDropdown && props.showQuizDropdown) {
      props.toggleQuizDropdown()
    }
    if (props.toggleNavbar && props.showNavbar) {
      props.toggleNavbar()
    }
  },
  closeEndorsementDropdown: props => e => {
    if (props.toggleEndorsementDropdown && props.showEndorsementDropdown) {
      props.toggleEndorsementDropdown()
    }
    if (props.toggleNavbar && props.showNavbar) {
      props.toggleNavbar()
    }
  },
  closeAboutDropdown: props => e => {
    if (props.toggleAboutDropdown && props.showAboutDropdown) {
      props.toggleAboutDropdown()
    }
    if (props.toggleNavbar && props.showNavbar) {
      props.toggleNavbar()
    }
  }
}

export default compose(translate(), withRouter, withHandlers(handlers))(SiteNav)



// WEBPACK FOOTER //
// ./src/components/siteNav/siteNavComponent.js